import type { AxiosResponse } from "axios";
import type { HttpClient } from "@/services/baseClient";
import { buildQueryString } from "@/services/baseClient";
import type {
  ApiResponse,
  LapCandidateFacets,
  LapCandidate,
  LapCandidateFilters,
  LapCandidatesResponse,
  LapComparisonResponse,
} from "@/types";

export interface LapComparisonParams {
  /** `<sessionId>:<lapNumber>` */
  ref: string;
  cmp: string;
  channels?: string[];
  maxPoints?: number;
}

export function createLapComparisonApi({ client }: HttpClient) {
  return {
    async getLapComparison(
      params: LapComparisonParams,
    ): Promise<LapComparisonResponse> {
      const query = buildQueryString({
        ref: params.ref,
        cmp: params.cmp,
        channels: params.channels?.length ? params.channels.join(",") : undefined,
        maxPoints: params.maxPoints,
      });
      const response: AxiosResponse<ApiResponse<LapComparisonResponse>> =
        await client.get(`/lap-comparison${query}`);
      return response.data.data;
    },

    async getLapCandidates(
      filters: LapCandidateFilters,
    ): Promise<LapCandidatesResponse> {
      const query = buildQueryString({
        trackId: filters.trackId,
        scope: filters.scope,
        driverId: filters.driverId,
        vehicleId: filters.vehicleId,
        from: filters.from,
        to: filters.to,
        maxLapTimeMs: filters.maxLapTimeMs,
        includeInvalid: filters.includeInvalid,
        orderBy: filters.orderBy,
        limit: filters.limit,
        offset: filters.offset,
      });
      const response: AxiosResponse<{
        success: boolean;
        data: { items: LapCandidate[]; facets: LapCandidateFacets };
        meta: { total: number; limit: number; offset: number };
      }> = await client.get(`/lap-comparison/candidates${query}`);
      return {
        items: response.data.data.items,
        facets: response.data.data.facets,
        meta: response.data.meta,
      };
    },
  };
}
